import request from '../config/axiosConfig';
import { LOGIN, LOGOUT, REFRESH_SESSION, UPDATE_PROFILE } from '../constants/apiEndPoint';

export const refreshSessionRequest = async (refreshKey, userId) => {
  const result = await request({
    url: REFRESH_SESSION,
    method: 'POST',
    data: { refresh_key: refreshKey, user_id: userId },
  });
  return result?.data;
};


export const loginRequest = async (data) => {
  const result = await request({
    url: LOGIN,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const logoutRequest = async (data) => {
    const result = await request({
      url: LOGOUT,
      method: 'POST',
      data,
    });
    return result?.data;
  };

export const updateInfoRequest = async (data) => {
  const result = await request({
    url: UPDATE_PROFILE,
    method: 'POST',
    data,
  });
  return result?.data;
};
